import React from 'react'
import "../styles/pageStyles/Chat.scss"
import ChatHeader from '../components/Chat/ChatHeader'
import ChattingArea from '../components/Chat/ChattingArea'

const Chat = () => {
    return (
        <div className='chat'>
            <ChatHeader />
            <ChattingArea />
        </div>
    )
}

export default Chat